import * as Yup from 'yup';
import { Formik } from 'formik';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Button,
  // Divider,
  Link,
  TextField,
  Typography,
  CircularProgress,
  // styled
} from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import useRefMounted from 'src/hooks/useRefMounted';
import { useTranslation } from 'react-i18next';

const loginErrorMessage = (error) => {
  switch (error?.code) {
    case 'auth/invalid-login-credentials':
    case 'auth/invalid-credential':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      return 'The email or password is incorrect.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Contact support.';
    case 'auth/too-many-requests':
      return 'Too many sign-in attempts. Wait a few minutes and try again.';
    case 'auth/network-request-failed':
      return 'The network is unavailable. Check your connection and try again.';
    default:
      return 'Unable to sign in right now. Please try again.';
  }
};

// const ImgWrapper = styled('img')(
//   ({ theme }) => `
//     margin-right: ${theme.spacing(1)};
// `
// );

function LoginFirebaseAuth() {
  // const { signInWithEmailAndPassword, signInWithGoogle } = useAuth();
  const { signInWithEmailAndPassword } = useAuth();

  const isMountedRef = useRefMounted();
  const { t } = useTranslation();

  // const handleGoogleClick = async () => {
  //   try {
  //     await signInWithGoogle();
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  return (
    <>
      {/* <Button
        fullWidth
        onClick={handleGoogleClick}
        size="large"
        variant="outlined"
      >
        <ImgWrapper alt="Google" src="/static/images/logo/google.svg" />
        Sign in with Google
      </Button>
      <Divider
        sx={{
          mt: 4,
          mb: 2
        }}
      >
        {t('or')}
      </Divider> */}
      <Formik
        initialValues={{
          email: '',
          password: '',
          submit: null
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email(t('The email provided should be a valid email address'))
            .max(255)
            .required(t('The email field is required')),
          password: Yup.string().max(255).required(t('The password field is required'))
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            await signInWithEmailAndPassword(values.email, values.password);

            if (isMountedRef.current) {
              setStatus({ success: true });
              setSubmitting(false);
            }
          } catch (err) {
            console.error(err);
            if (isMountedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: loginErrorMessage(err) });
              setSubmitting(false);
            }
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <TextField
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              label={t('Email address')}
              placeholder={t('Your email address here...')}
              margin="normal"
              name="email"
              onBlur={handleBlur}
              onChange={handleChange}
              type="email"
              autoComplete="email"
              value={values.email}
              variant="outlined"
            />
            <TextField
              error={Boolean(touched.password && errors.password)}
              fullWidth
              helperText={touched.password && errors.password}
              label={t('Password')}
              placeholder={t('Your password here...')}
              margin="normal"
              name="password"
              onBlur={handleBlur}
              onChange={handleChange}
              type="password"
              autoComplete="current-password"
              value={values.password}
              variant="outlined"
            />
            <Box display="flex" justifyContent="flex-end" sx={{ mt: 1 }}>
              <Link component={RouterLink} to="/account/recover-password">
                <b>{t('Lost password?')}</b>
              </Link>
            </Box>
            {errors.submit && (
              <Typography color="error" variant="body2" sx={{ mt: 2 }} role="alert">
                {errors.submit}
              </Typography>
            )}
            <Button
              sx={{
                mt: 3
              }}
              color="primary"
              startIcon={isSubmitting ? <CircularProgress size="1rem" /> : null}
              disabled={isSubmitting}
              size="large"
              fullWidth
              type="submit"
              variant="contained"
            >
              {t('Sign in')}
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
}

export default LoginFirebaseAuth;
